import IconButton, { IconButtonProps } from "@material-ui/core/IconButton"
import { wrapLink, LinkProps } from "./Link";


export type IconButtonLinkProps = Omit<IconButtonProps, "component"> & LinkProps;
export const IconButtonLink = wrapLink<IconButtonLinkProps>(IconButton);